import { isDefined } from "@banjoanton/utils";
import type { Move } from "../models/move-model";

const getSquaresAttackedByFork = (previousMoves: Move[] | undefined) => {
    const forkedSquares: string[] = [];
    if (!isDefined(previousMoves)) {
        return forkedSquares;
    }

    const lastMove = previousMoves[previousMoves.length - 1];
    if (!isDefined(lastMove?.analysis?.annotations)) {
        return forkedSquares;
    }

    const forkAnnotations = lastMove.analysis.annotations.filter(
        (a) => a.type === "fork"
    );

    for (const forkAnnotation of forkAnnotations) {
        for (const attackedPiece of forkAnnotation.targets) {
            forkedSquares.push(attackedPiece.square);
        }
    }

    return forkedSquares;
};

export const ForkUtil = {
    getSquaresAttackedByFork,
};
